import { Form, Select } from 'antd'
import Check from './Check'
import Schedule from './Schedule'
import List from './List'
import { useEffect } from 'react'

const actions = [
  {
    label: 'Checar Disponibilidade',
    value: 'CHECK',
  },
  {
    label: 'Marcar Horário',
    value: 'SCHEDULE',
  },
  {
    label: 'Horários disponíveis',
    value: 'LIST',
  },
]

export default function GoogleCalendarForm({ form, parameters, fieldName }) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'CHECK' && (
        <Check fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'SCHEDULE' && (
        <Schedule fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'LIST' && (
        <List fieldName={fieldName} parameters={parameters} />
      )}
    </>
  )
}
